<template>
  <div
    ref="contextMenu"
    class="context-menu"
    :style="{
      left: `${x}px`,
      top: `${y}px`
    }"
    @click.stop
  >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'ContextMenu',
  props: {
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },
  mounted () {
    document.addEventListener('click', this.handleOutsideClick)
  },

  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    handleOutsideClick (event) {
      const menu = this.$refs.contextMenu

      if (!menu || menu.contains(event.target)) {
        return
      }

      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.context-menu {
  position: fixed;
  padding: var(--s);
  box-shadow: $color__card-box-shadow--dropdown;
  background-color: $color__background--main;
  border-radius: 20px;
  z-index: 1000;

  & > *:not(:last-child) {
    margin-bottom: var(--s);
  }
}
</style>
